import React from "react";
import { FaEye, FaLock, FaTimes, FaUnlock, FaDownload } from "react-icons/fa";
import {
  PrimaryButton,
  SecondaryButton,
  DangerButton,
} from "../../UI/DesignStandards";
import { getResultsAdminControls } from "./resultsAdminControls";

const compactSecondary = "!px-3 !py-2 text-sm";

const TournamentResultsHeader = ({
  tournamentName,
  canManage,
  isPayoutFinalized,
  isResultsFinalized,
  isPreviewingPayouts = false,
  onVerifyPayouts,
  onUnlockPayouts,
  onCancelPreview,
  onSetShowPayouts,
  onGeneratePDF,
  onGenerateCSV,
  isGeneratingPDF = false,
  loading,
}) => {
  const { action, showCancel } = getResultsAdminControls({
    canManage,
    isPayoutFinalized,
    isResultsFinalized,
    isPreviewingPayouts,
  });

  return (
    <header
      className="flex flex-wrap gap-2 w-full lg:w-auto justify-start lg:justify-end"
      role="toolbar"
      aria-label={`Tournament results actions for ${
        tournamentName || "tournament"
      }`}
    >
      {action === "lock" ? (
        <div
          className="flex flex-wrap gap-2"
          role="group"
          aria-label="Payout preview actions"
        >
          <PrimaryButton
            onClick={onVerifyPayouts}
            disabled={loading}
            icon={FaLock}
            aria-label="Lock results"
            title="Lock results to prevent further modifications"
          >
            Lock Results
          </PrimaryButton>
          {showCancel ? (
            <DangerButton
              onClick={onCancelPreview}
              disabled={loading}
              icon={FaTimes}
              aria-label="Cancel payout preview"
              title="Cancel payout preview and return to Preview Payouts"
            >
              Cancel
            </DangerButton>
          ) : null}
        </div>
      ) : null}

      {action === "preview" ? (
        <PrimaryButton
          onClick={() => onSetShowPayouts(true)}
          disabled={loading}
          icon={FaEye}
          aria-label="Preview tournament payouts"
          title="Preview tournament payouts before finalizing"
        >
          Preview Payouts
        </PrimaryButton>
      ) : null}

      {action === "unlock" ? (
        <SecondaryButton
          onClick={onUnlockPayouts}
          disabled={loading}
          icon={FaUnlock}
          className={compactSecondary}
          aria-label="Unlock results for editing"
          title="Unlock results to allow further modifications"
        >
          Unlock Results
        </SecondaryButton>
      ) : null}

      <SecondaryButton
        onClick={onGeneratePDF}
        disabled={loading || isGeneratingPDF}
        icon={!isGeneratingPDF ? FaDownload : undefined}
        className={compactSecondary}
        aria-label="Download tournament results as PDF"
        title="Download tournament results as a PDF document"
      >
        {isGeneratingPDF ? "Generating PDF..." : "Download PDF"}
      </SecondaryButton>
      {isGeneratingPDF && (
        <span className="sr-only" aria-live="polite">
          Generating PDF, your download will begin shortly.
        </span>
      )}

      <SecondaryButton
        onClick={onGenerateCSV}
        disabled={loading}
        icon={FaDownload}
        className={compactSecondary}
        aria-label="Export tournament results as CSV"
        title="Export tournament results as a CSV spreadsheet"
      >
        Export CSV
      </SecondaryButton>

      {/* Screen reader announcements for loading states */}
      {loading && (
        <div className="sr-only" aria-live="polite">
          Processing tournament results, please wait...
        </div>
      )}
    </header>
  );
};

export default TournamentResultsHeader;
